import React from 'react';

function ToneSelector({ selected, onChange, options }) {
  const toggleOption = (value) => {
    if (selected.includes(value)) {
      onChange(selected.filter(item => item !== value));
    } else {
      onChange([...selected, value]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => toggleOption(option.value)}
          className={`px-4 py-2 rounded-full border-2 transition-colors ${
            selected.includes(option.value)
              ? 'bg-blue-600 text-white border-blue-600'
              : 'bg-white text-gray-700 border-gray-300 hover:border-blue-400'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default ToneSelector;
